import React from "react";
import TotoHome from "@/pages/TotoHome";

// Toto Home v1 is intentionally a thin shell over the existing product.
// Front-line role handling remains inside TotoHome, while Payroll, Reviews,
// Team, and every backend workflow continue to use their existing routes.
// The previous Home implementation remains preserved in git history on main.
export default function Home() {
  return <TotoHome />;
}
